import styles from './TableSkeleton.module.scss';

export interface ITableSkeletonProps {
    numberOfRows?: number;
    numberOfColumns?: number;
    hasHeaderRow?: boolean;
}

const defaultNumberOfRows = 8;
const defaultNumberOfColumns = 5;

const dataBarWidthsByColumnIndex = ['70%', '50%', '45%', '55%', '40%'];
const headerBarWidthsByColumnIndex = ['55%', '45%', '50%', '40%', '45%'];

const TableSkeleton: React.FC<ITableSkeletonProps> = (props: ITableSkeletonProps) => {
    const numberOfRows = props.numberOfRows ?? defaultNumberOfRows;
    const numberOfColumns = props.numberOfColumns ?? defaultNumberOfColumns;
    const hasHeaderRow = props.hasHeaderRow ?? true;
    const alternatingRowClass = `${styles.table_skeleton_data_row} ${styles.table_skeleton_data_row_alternating}`;

    const headerCellKeys = Array.from({ length: numberOfColumns }, (_, index) => `header-cell-${index}`);
    const rowKeys = Array.from({ length: numberOfRows }, (_, index) => `data-row-${index}`);
    const cellKeysByRow = rowKeys.map((rowKey) => Array.from({ length: numberOfColumns }, (_, index) => `${rowKey}-cell-${index}`));

    return (
        <div className={styles.table_skeleton}>
            {hasHeaderRow && (
                <div className={styles.table_skeleton_header_row}>
                    {headerCellKeys.map((key, columnIndex) => (
                        <div key={key} className={styles.table_skeleton_header_cell}>
                            <div
                                className={styles.table_skeleton_header_bar}
                                style={{ width: headerBarWidthsByColumnIndex[columnIndex % headerBarWidthsByColumnIndex.length] }}
                            />
                        </div>
                    ))}
                </div>
            )}
            {rowKeys.map((rowKey, rowIndex) => (
                <div key={rowKey} className={rowIndex % 2 === 1 ? alternatingRowClass : styles.table_skeleton_data_row}>
                    {cellKeysByRow[rowIndex].map((cellKey, columnIndex) => (
                        <div key={cellKey} className={styles.table_skeleton_data_cell}>
                            <div
                                className={styles.table_skeleton_data_bar}
                                style={{ width: dataBarWidthsByColumnIndex[columnIndex % dataBarWidthsByColumnIndex.length] }}
                            />
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
};

export default TableSkeleton;
